// Health (MUI, /health). Presentation port of HealthPage — phase placeholders
// for audit/reliability surfaces, rebuilt with mui/* primitives + brainTokens.
import { Box } from "@mui/material";
import { brainTokens } from "../../design/brainTheme";
import { PageHeader, SectionCard, StatusPill } from "../../mui";

const c = brainTokens.color;

function PhaseEmptyStateMui({ title, phase, children }: { title: string; phase: string; children: string }) {
  return (
    <SectionCard>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 1 }}>
        <Box sx={{ fontSize: 15, fontWeight: 500, color: c.ink }}>{title}</Box>
        <StatusPill tone="neutral" label={`Needs ${phase}`} />
      </Box>
      <Box sx={{ fontSize: 13, color: c.muted2 }}>{children}</Box>
    </SectionCard>
  );
}

export function HealthPageMui() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <PageHeader title="Health" eyebrow="Audit and reliability" />
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: 2 }}>
        <PhaseEmptyStateMui title="Nightly Audit" phase="Phase 6 / GET /admin/health">
          Brain health reports from S3 are not generated by the current frontend-facing surface.
        </PhaseEmptyStateMui>
        <PhaseEmptyStateMui title="Contradictions" phase="Phase 6 / GET /admin/audit">
          Contradiction and duplicate-candidate counts need the audit log endpoint.
        </PhaseEmptyStateMui>
        <PhaseEmptyStateMui title="Usage" phase="Phase 6 / GET /admin/usage">
          Search, capture, zero-result, and useful-vote aggregates need the usage stats surface.
        </PhaseEmptyStateMui>
      </Box>
    </Box>
  );
}
